module.exports = __webpack_public_path__ + "img/bg_1@2x.053ae79b.png";